import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux';
import { AppRouter } from './routers/AppRouter';
import { store } from './Store/store';
import { getSession } from './Helpers/Routers_helper';
import 'react-dropzone-uploader/dist/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import './Helpers/fontawesome.js';
import './assets/styles/combined.scss';
import 'react-dates/initialize';
import 'moment/locale/es-mx';
import 'react-dates/lib/css/_datepicker.css';
import './assets/styles/react_dates_overrides.css';

const MainApp = () => {

    const [stateSesion, setStateSesion] = useState(false);

    useEffect(() => {
        getSession(setStateSesion);
    }, [])

    return (
        <Provider store={ store }>
            <AppRouter stateSesion={stateSesion} setStateSesion={setStateSesion}  />
        </Provider>
    )
}

export default MainApp
